import { RouterProvider } from '@tanstack/react-router';

import { routerRef } from '@/util/routerRef';
import useGainsightTag from '@/util/useGainsightTag';

import { CircularProgress } from './components/ui/circular-progress';

export const Router = {
	navigate: (opts) => {
		const r = routerRef.current;
		if (r) r.navigate(typeof opts === 'string' ? { to: opts } : opts);
	},
	state: {
		get location() {
			return routerRef.current?.state?.location;
		},
	},
};

export function getRouterInstance() {
	return routerRef.current;
}

const Routes = () => {
	useGainsightTag();
	const router = routerRef.current;
	if (!router) {
		return (
			<div id="initial-overlay" className="flex items-center flex-col fixed inset-0 bg-white justify-center">
				<CircularProgress id="initial-loader" variant="circular" size="lg" />
			</div>
		);
	}
	return <RouterProvider router={router} />;
};

export default Routes;
